import Vue from "vue";
import Page from "./index.vue";

new Vue({render: h => h(Page)}).$mount("#app");